import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CabinetConfigurationState, ConfigurationChangeModel, CabinetConfigurationSettingsModel } from '@/types';

export const state: CabinetConfigurationState = {
  cabinetConfigurationChange: {} as ConfigurationChangeModel,
  cabinetConfigurationSettings: {} as CabinetConfigurationSettingsModel,
  isLoading: false,
  error: false,
  errorMessage: ''
};

const namespaced: boolean = true;

export const cabinetConfiguration = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};